import React from 'react';
import './Agreement.css';

const Agreement = () => {
  // Ви можете зробити ці дані динамічними, якщо потрібно
  const lastUpdated = "September 19, 2025";
  const companyName = "Kilochyk Oleksii Oleksandrovych (Individual Entrepreneur)";

  return (
    <div className="agreement-wrapper">
      <div className="agreement-container">
        <header className="agreement-header">
          <h1>Privacy Policy and Personal Data Protection</h1>
          <p>
            Last updated: {lastUpdated}
          </p>
          <p> 
            Legal entity name: {companyName} 
          </p>
          <p> 
          Website: https://pryvitai.com - holiday reminder service 
          with text and image generation functionality for greetings. 
          </p>
        </header>

        <section className="agreement-content">
          <div className="policy-section">
            <h2>1. General Provisions</h2>
            <p>This Privacy Policy explains how We collect, use, store and protect users' personal data ("You", "User"). By using our Service, You confirm that You have read this Policy and agree to its terms.</p>
          </div>

          <div className="policy-section">
            <h2>2. What Data We Collect</h2>
            <p>We may collect and process the following categories of data:</p>
            <ul>
              <li><strong>Contact Information:</strong> email, phone number, name, and other information You voluntarily provide during registration.</li>
              <li><strong>Photos and Images:</strong> data You upload to the Service (for example, photos of greeting recipients).</li>
              <li><strong>Additional Information:</strong> about greeting recipients, their hobbies, interests, activities, character traits and values for recommendations and creating more personalized greeting ideas.</li>
              <li><strong>Generated Data:</strong> texts, images and other content created using the Service.</li>
              <li><strong>Technical Information:</strong> IP address, cookies, device information and activity in the Service.</li>
            </ul>
          </div>

          <div className="policy-section">
            <h2>3. Purpose of Data Collection and Use</h2>
            <p>Your data is used exclusively for:</p>
            <ul>
              <li>registration and authorization in the Service;</li>
              <li>providing greeting and image generation services;</li>
              <li>sending service messages and event reminders;</li>
              <li>improving Service performance and analytics;</li>
              <li>fulfilling legal obligations.</li>
            </ul>
          </div>

          <div className="policy-section">
            <h2>4. Data Transfer to Third Parties</h2>
            <p>We may transfer Your data only in the following cases: to technical service providers (hosting, image processing, payment services); as required by law or competent authorities; in cases with Your direct consent. We do not sell personal data to third parties.</p>
          </div>

          <div className="policy-section">
            <h2>5. Responsibility for Content and Photos</h2>
            <p>You bear personal responsibility for ensuring that photos and other data uploaded by You do not violate third party rights (copyright, privacy rights, consent for use of person's image). We do not verify or confirm the accuracy of data provided by You. In case of claims from third parties, responsibility for uploaded content lies solely with the User.</p>
          </div>

          <div className="policy-section">
            <h2>6. Data Storage</h2>
            <p>Data is stored for as long as necessary to provide services. You can contact us at any time with a request to delete your data. Photos uploaded by You may be deleted after completion of the generation process, unless otherwise provided by Service settings.</p>
          </div>

          <div className="policy-section">
            <h2>7. Data Protection</h2>
            <p>We apply modern technical and organizational measures to protect data, including encryption, controlled access and security monitoring.</p>
          </div>

          <div className="policy-section">
            <h2>8. User Rights</h2>
            <p>You have the right to: access your data; correct or update it; request deletion; withdraw consent for processing; file a complaint with a supervisory authority (in accordance with local legislation).</p>
          </div>

          <div className="policy-section">
            <h2>9. Use of Service by Minors</h2>
            <ul>
              <li><strong>Service Access:</strong> The Service may be used by minors with consent of parents or guardians, or in the absence of their objection to using the service.</li>
              <li><strong>Payment for tariffs and balance top-up:</strong> Payment for tariffs or balance top-up can only be made by an adult or a minor with their own bank card, legally issued with permission from parents or guardians.</li>
            </ul>
          </div>

          <div className="policy-section">
            <h2>10. Policy Changes</h2>
            <p>We may update this Policy from time to time. All changes will be published on this page with the corresponding date.</p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Agreement;